import env from "../config/env";

export const endpoints = {
  listUsers: () => `${env.gitdashUsersUrl}?key=${env.gitdashApiKey}`,
  trackIssues: (username) =>
    `${env.gitdashBaseUrl}?username=${encodeURIComponent(username)}`,
};
